"use client";

import { useEditsChildWidth } from "@/hooks/useEditsChildWidth";
import { cn } from "@/lib/tailwind";
import { useRef } from "react";
import { CLink } from "../customLink/CustomLink";
import RenderCurrencyInText from "../RenderCurrencyInText";
import { HeaderVariantWithTabs } from "./type";

const WithTabs = ({ tabs }: HeaderVariantWithTabs) => {
  const tabsRef = useRef<HTMLDivElement>(null);
  const { isEditsCenter } = useEditsChildWidth(tabsRef);

  return (
    <div
      className={cn(
        "no-scrollbar flex items-center gap-3 overflow-auto px-4 md:justify-center",
        isEditsCenter ? "justify-center" : "justify-start",
      )}
      ref={tabsRef}
    >
      {tabs?.map((t, i) => (
        <CLink key={i} href={t?.href}>
          <div
            className={cn(
              "flex h-[34px] flex-shrink-0 items-center whitespace-nowrap px-2 py-[9px] text-xs md:h-10 md:px-5 md:py-3 md:text-sm",
              t.active
                ? "border-[1px] border-tertiary-13 text-tertiary-13"
                : "border-[1px] border-black",
            )}
            onClick={() => {
              if (t.handleSelectedEdits !== undefined && t.index !== undefined) {
                t.handleSelectedEdits(t.index);
              }
            }}
          >
            <RenderCurrencyInText text={t.label} />
          </div>
        </CLink>
      ))}
    </div>
  );
};

export default WithTabs;
